import 'babel-polyfill'
import React from 'react';
import ReactDom from 'react-dom';
import { Provider } from 'react-redux';
import { Router, Route, IndexRoute, browserHistory } from 'react-router';

import store, { history } from './store';

import App from './app/components/App';
import Home from './app/components/Home';
import Security from './app/components/Security';
import SecurityHome from './app/components/SecurityHome';
import TwoStepVerificationPassword from './app/components/security/password/TwoStepVerificationPassword';
import TwoStepVerificationRealInfo from './app/components/security/realinfo/TwoStepVerificationRealInfo'
import TwoStepVerificationOTPRevoke from './app/components/security/password/TwoStepVerificationOTPRevoke';
import ChangePassword from './app/components/security/password/ChangePassword';
import InitPassword from './app/components/security/password/InitPassword';
import DonePassword from './app/components/security/password/DonePassword';
import ContactCustomerService from './app/components/security/password/ContactCustomerService';
import ContactCustomerServiceEmail from './app/components/security/email/ContactCustomerService';
import NeedBindMobile from './app/components/security/password/NeedBindMobile';
import TwoStepVerificationMobile from './app/components/security/mobile/TwoStepVerificationMobile';
import ApplyMobile from './app/components/security/mobile/ApplyMobile';
import VerifyMobile from './app/components/security/mobile/VerifyMobile';
import SaveMobile from './app/components/security/mobile/SaveMobile';
import DoneRevokeToken from './app/components/security/password/DoneRevokeToken';
import DoneMobile from './app/components/security/mobile/DoneMobile';
import ErrorCommon from './app/components/security/ErrorCommon';
import TwoStepVerificationEmail from './app/components/security/email/TwoStepVerificationEmail';
import SaveEmail from './app/components/security/email/SaveEmail';
import SaveRealinfo from './app/components/security/realinfo/SaveRealinfo';
import DoneRealinfo from './app/components/security/realinfo/DoneRealinfo';
import UpdateRealinfo from './app/components/security/realinfo/UpdateRealinfo';
import ApplyEmail from './app/components/security/verify_email/ApplyEmail';
import VerifyEmail from './app/components/security/verify_email/VerifyEmail';
import DoneVerifyEmail from './app/components/security/verify_email/DoneVerifyEmail';
import NotBindMobile from './app/components/security/authenticator/NotBindMobile';
import NotBindEmail from './app/components/security/authenticator/NotBindEmail';
import SaveAuthenticator from './app/components/security/authenticator/SaveAuthenticator';
import TwoStepVerificationAuthenticator from './app/components/security/authenticator/TwoStepVerificationAuthenticator';
import DoneSaveAuthenticator from './app/components/security/authenticator/DoneSaveAuthenticator';
import DoneRevokeAuthenticator from './app/components/security/authenticator/DoneRevokeAuthenticator';
import TwoStepVerificationGameOTP from './app/components/security/game_otp/TwoStepVerificationGameOTP';
import SaveGameOTP from './app/components/security/game_otp/SaveGameOTP';
import DoneGameOTP from './app/components/security/game_otp/DoneGameOTP';
import InitFacebookConnect from './app/components/security/facebook/InitFacebookConnect'
import ProceedFacebookConnect from './app/components/security/facebook/ProceedFacebookConnect'
import ErrorSecurity from './app/components/security/ErrorSecurity';
import DoneSecurity from './app/components/security/DoneSecurity';
import UnlockIndex from './app/components/unlock/UnlockIndex';
import UnlockVerify from './app/components/unlock/UnlockVerify';
import UnlockChangePassword from './app/components/unlock/UnlockChangePassword';
import UnlockDone from './app/components/unlock/UnlockDone';
import LoginHistory from './app/components/LoginHistory';
import SensitiveOperation from './app/components/SensitiveOperation';
import FAQ from './app/components/FAQ';
import ErrorServer from './app/components/ErrorServer';
import ErrorRetry from './app/components/ErrorRetry';
import ErrorAction from './app/components/ErrorAction';
import ErrorExpiredLink from './app/components/ErrorExpiredLink';
import ErrorSuspiciousIP from './app/components/ErrorSuspiciousIP';
import SuccessVerifyEmail from './app/components/SuccessVerifyEmail';
import NoEmailRealinfo from './app/components/security/realinfo/NoEmailRealinfo';
import UnverifiedEmailRealinfo from './app/components/security/realinfo/UnverifiedEmailRealinfo';

ReactDom.render(
	<Provider store={ store }>
			<Router history={ history }>
				<Route path="/error_link" component={ErrorExpiredLink} />
				<Route path="/error_login" component={ErrorSuspiciousIP} />
				<Route path="/success_verify_email" component={SuccessVerifyEmail} />
				<Route path="/" component={App}>
					<IndexRoute component={Home} />
					<Route path="security" component={Security}>
						<IndexRoute component={SecurityHome} />
						<Route path="error/:error" component={ErrorCommon} />
						<Route path="password/2-step-verification" component={TwoStepVerificationPassword} />
						<Route path="otp_revoke/2-step-verification" component={TwoStepVerificationOTPRevoke} />
						<Route path="otp_revoke/done" component={DoneRevokeToken} />
						<Route path="password/init" component={InitPassword} />
						<Route path="password/change" component={ChangePassword} />
						<Route path="password/done" component={DonePassword} />
						<Route path="password/contact-customer-service" component={ContactCustomerService} />
						<Route path="password/need-bind-mobile" component={NeedBindMobile} />
						<Route path="mobile/2-step-verification" component={TwoStepVerificationMobile} />
						<Route path="mobile/apply" component={ApplyMobile} />
						<Route path="mobile/verify" component={VerifyMobile} />
						<Route path="mobile/save" component={SaveMobile} />
						<Route path="mobile/done" component={DoneMobile} />
						<Route path="email/2-step-verification" component={TwoStepVerificationEmail} />
						<Route path="email/contact-customer-service" component={ContactCustomerServiceEmail} />
						<Route path="email/save" component={SaveEmail} />
						<Route path="realinfo/save" component={SaveRealinfo} />
						<Route path="realinfo/done" component={DoneRealinfo} />
						<Route path="realinfo/2-step-verification" component={TwoStepVerificationRealInfo} />
						<Route path="realinfo/update" component={UpdateRealinfo} />
						<Route path="realinfo/no_email" component={NoEmailRealinfo} />
						<Route path="realinfo/unverified_email" component={UnverifiedEmailRealinfo} />
						<Route path="verify_email/apply" component={ApplyEmail} />
						<Route path="verify_email/verify" component={VerifyEmail} />
						<Route path="verify_email/done" component={DoneVerifyEmail} />
						<Route path="authenticator/no_mobile" component={NotBindMobile} />
						<Route path="authenticator/no_email" component={NotBindEmail} />
						<Route path="authenticator/2-step-verification" component={TwoStepVerificationAuthenticator} />
						<Route path="authenticator/save" component={SaveAuthenticator} />
						<Route path="authenticator/done_save" component={DoneSaveAuthenticator} />
						<Route path="authenticator/done_revoke" component={DoneRevokeAuthenticator} />
						<Route path="game_otp/2-step-verification" component={TwoStepVerificationGameOTP} />
						<Route path="game_otp/save" component={SaveGameOTP} />
						<Route path="game_otp/done" component={DoneGameOTP} />
						<Route path="done" component={DoneSecurity} />
						<Route path="error_security" component={ErrorSecurity} />
						<Route path="error_action" component={ErrorAction} />
						<Route path="error_retry" component={ErrorRetry} />
						<Route path="error_server" component={ErrorServer} />
					</Route>
					<Route path="fbSecurity" component={Security}>
						<Route path="facebookConnect/init" component={InitFacebookConnect} />
						<Route path="facebookConnect/proceed" component={ProceedFacebookConnect} />
					</Route>
					<Route path="login-history" component={LoginHistory} />
					<Route path="sensitive-operation" component={SensitiveOperation} />
					<Route path="unlock/index" component={UnlockIndex} />
					<Route path="unlock/verify" component={UnlockVerify} />
					<Route path="unlock/change_password" component={UnlockChangePassword} />
					<Route path="unlock/done" component={UnlockDone} />
					<Route path="faq" component={FAQ} />
				</Route>
			</Router>
	</Provider>,
	document.getElementById("main")
);


// WEBPACK FOOTER //
// ./index.js